import { Injectable, Signal, signal } from '@angular/core';
import { MenuItem } from './types';

@Injectable({
  providedIn: 'root',
})
export class ActionService {
  public readonly actions: Signal<MenuItem[]>;
  private readonly _actions = signal<MenuItem[]>([]);

  constructor() {
    this.actions = this._actions.asReadonly();
  }

  public set(items: MenuItem[]) {
    this._actions.set(items);
  }
}
